import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const HectoResultMob = () => {
  return <CommonResult />;
};

export default HectoResultMob;
